import * as React from "react";
import { TouchableOpacity, View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import ChevronRight from "@assets/svg/ChevronRight";
import color from "@constants/color";

const ListItem = ({ title, onPress }) => (
  <TouchableOpacity onPress={onPress}>
    <View
      style={{
        flexDirection: "row",
        paddingLeft: 25,
        paddingVertical: 15,
        paddingRight: 40,
        backgroundColor: "white",
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: color.searchBg,
        marginTop: 1,
      }}
    >
      <Text
        variant="body_text_3"
        style={{
          flex: 1,
          color: color.mediumBlack,
        }}
      >
        {title}
      </Text>

      <View
        style={{
          width: 30,
          height: 30,
          position: "absolute",
          right: 25,
          top: 10,
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <ChevronRight pathFill="#E40046" width={8} height={20} />
      </View>
    </View>
  </TouchableOpacity>
);

export default ListItem;
